import React from "react";

export default function ({address}) {

  return (
    <div className="col-xxl-6 pt-5">
      <div className="card card-flush py-4 flex-row-fluid">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="card-title">
            <h2>Shipping Address</h2>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="table-responsive">
            <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
              <tbody className="fw-bold text-gray-600">
              <tr>
                <td className="text-muted">
                      <span className="d-flex align-items-center">
                        Full Name
                      </span>
                </td>
                <td className="fw-bolder text-end">
                      <span className="d-flex align-items-center justify-content-end">
                        {address.first_name} {address.last_name}
                      </span>
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                      <span className="d-flex align-items-center">
                        Address Type
                      </span>
                </td>
                <td className="fw-bolder text-end">
                  {address?.address_type}
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                      <span className="d-flex align-items-center">
                        Address
                      </span>
                </td>
                <td className="fw-bolder text-end">{address?.address}</td>
              </tr>
              <tr>
                <td className="text-muted">
                      <span className="d-flex align-items-center">
                        ID number
                      </span>
                </td>
                <td className="fw-bolder text-end">{address?.personal_number}</td>
              </tr>
              <tr>
                <td className="text-muted">
                      <span className="d-flex align-items-center">
                        Phone
                      </span>
                </td>
                <td className="fw-bolder text-end">{address?.phone}</td>
              </tr>
              <tr>
                <td className="text-muted">
                      <span className="d-flex align-items-center">
                        Comment
                      </span>
                </td>
                <td className="fw-bolder text-end">{address?.comment}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}